/* Native Green Glass pack selection. Shopify remains the source of truth for inventory and discounts. */
(() => {
  const enhanceStoreButton = () => {
    document.querySelectorAll('.ggp__pickup #findInStore').forEach(button => {
      if (button.tagName === 'BUTTON' || button.dataset.ggAccessible) return;
      button.dataset.ggAccessible = 'true'; button.setAttribute('role', 'button'); button.tabIndex = 0;
      button.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); button.click(); }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceStoreButton, { once:true });
  else enhanceStoreButton();
  document.addEventListener('shopify:section:load', enhanceStoreButton);
})();
(() => {
  if (customElements.get('gg-buybox')) return;
  // Native percentage codes: GGBOX2 = 2.5% on 2 eligible packs (= 5% of the 2nd pack),
  // GGBOX3 = 5% on 3 eligible packs (= 5% of the 2nd + 10% of the 3rd). Based on the unit pack price.
  // Rounded down to whole CLP so the quoted saving never exceeds what Shopify applies.
  const roundMoney = value => Math.floor(value / 100) * 100;
  const discountFor = (count, price) => count >= 3 ? roundMoney(price * 3 * 0.05) : count >= 2 ? roundMoney(price * 2 * 0.025) : 0;
  const ROUNDING_TOLERANCE = 500;
  const choiceSelection = value => value === 'duet' ? { quantity:1, pair:true } : { quantity:Number(value), pair:false };
  const selectedOffer = (config, quantity, pair, bump, existing = 0) => {
    const pairs = Array.isArray(pair) ? pair : pair && config.pair ? [config.pair] : [];
    const packCount = quantity + pairs.filter(item => item.eligible).length;
    const after = existing + packCount;
    const base = config.price * quantity;
    const pairPrice = pairs.reduce((sum, item) => sum + item.price, 0);
    const bumpPrice = bump && config.bump ? config.bump.price : 0;
    const subtotal = base + pairPrice + bumpPrice;
    const unit = Number(config.price || 0);
    const saving = config.discountReady ? discountFor(after, unit) - discountFor(existing, unit) : 0;
    return { subtotal, saving, total: subtotal - saving, packCount,
      second: config.discountReady && existing < 2 && after >= 2,
      third: config.discountReady && existing < 3 && after >= 3,
      glasses: config.glasses * quantity + pairs.reduce((sum, item) => sum + item.glasses, 0) };
  };
  customElements.define('gg-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try { this.config = JSON.parse(this.querySelector('[data-ggbuy-config]').textContent); } catch { return; }
      this.config.pairs ||= this.config.pair ? [this.config.pair] : [];
      this.form = this.closest('form');
      this.product = this.closest('gg-product');
      this.quantity = this.querySelector('[name="quantity"]');
      this.button = this.querySelector('[name="add"]');
      this.status = this.closest('[data-gg-buy]').querySelector('[data-gg-buy-status]');
      this.money = value => new Intl.NumberFormat(this.dataset.currency === 'CLP' ? 'es-CL' : this.dataset.locale || 'es', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: this.dataset.currency || 'CLP', maximumFractionDigits: this.dataset.currency === 'CLP' ? 0 : 2 }).format(value / 100);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.existing = 0;
      const refreshCart = event => {
        if (event.detail?.cart?.items) this.setCart(event.detail.cart);
        else this.json('cart.js').then(cart => this.setCart(cart)).catch(() => {});
      };
      document.addEventListener('cart:updated', refreshCart, options);
      document.addEventListener('cart:refresh', refreshCart, options);
      this.addEventListener('change', event => {
        if (event.target.name === 'gg_pack_quantity') {
          const selected = choiceSelection(event.target.value);
          this.quantity.value = selected.quantity;
          if (this.config.duetLayout) this.querySelector('[data-ggbuy-extra="pair"]').checked = selected.pair;
        }
        if (this.config.duetLayout && event.target === this.quantity) this.querySelector('[data-ggbuy-extra="pair"]').checked = false;
        if (event.target.matches('[name="quantity"],[name="gg_pack_quantity"],[data-ggbuy-extra]')) this.update();
      }, options);
      this.addEventListener('click', event => {
        const move = event.target.closest('[data-ggbuy-pair-move]');
        if (move) { const track = this.querySelector('.ggbuy__pair-track'); const index = Math.round(track.scrollLeft / track.clientWidth); const next = (index + Number(move.dataset.ggbuyPairMove) + track.children.length) % track.children.length; track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
        if (event.target.closest('[name="add"]') === this.button) {
          event.preventDefault(); event.stopImmediatePropagation(); this.add();
        }
      }, options);
      const pairTrack = this.querySelector('.ggbuy__pair-track');
      pairTrack?.addEventListener('scroll', () => { const count = this.querySelector('[data-ggbuy-pair-count]'); if (count) count.textContent = `${Math.round(pairTrack.scrollLeft / pairTrack.clientWidth) + 1} / ${pairTrack.children.length}`; }, { ...options, passive: true });
      this.form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); this.add(); }, { ...options, capture: true });
      this.querySelectorAll('[data-ggbuy-enhanced]').forEach(element => { element.hidden = false; });
      this.ready = true; this.dataset.ready = 'true';
      this.update();
      if (this.config.discountReady) this.json('cart.js').then(cart => this.setCart(cart)).catch(() => {});
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.attentionObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.button.classList.add('ggbuy__add--attention');
            this.attentionObserver.disconnect();
          }
        }, { threshold: .8 });
        this.attentionObserver.observe(this.button);
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.attentionObserver?.disconnect(); this.ready = false; }
    setCart(cart) {
      const eligible = new Set(this.config.eligibleVariantIds || []);
      this.existing = (cart.items || []).reduce((count, item) => count + (eligible.has(String(item.variant_id)) && !item.selling_plan_allocation ? item.quantity : 0), 0);
      this.update();
    }
    selectedPairs() {
      const selected = new Set([...this.querySelectorAll('[data-ggbuy-extra="pair"]:checked')].map(input => Number(input.dataset.ggbuyPairId)));
      return this.config.pairs.filter(item => selected.has(item.id));
    }
    offerLabel(offer) {
      if (offer.second && offer.third) return this.config.labels.tierThree;
      if (offer.third) return this.config.labels.tierThirdOnly;
      return offer.second ? this.config.labels.tierTwo : '';
    }
    update() {
      const quantity = Number(this.quantity.value);
      const valid = Number.isInteger(quantity) && quantity >= 1 && quantity <= this.config.max;
      this.button.disabled = !valid || this.busy;
      const pairs = this.selectedPairs();
      const professorNotice = this.querySelector('[data-gg-profesores-selected]');
      if (professorNotice) professorNotice.hidden = !pairs.some(item => Number(item.id) === 41763429449793);
      const pair = pairs.length > 0;
      const bump = Boolean(this.querySelector('[data-ggbuy-extra="bump"]')?.checked);
      this.offer = selectedOffer(this.config, valid ? quantity : 1, pairs, bump, this.existing);
      this.querySelectorAll('[name="gg_pack_quantity"]').forEach(input => { input.checked = input.value === 'duet' ? quantity === 1 && pair : Number(input.value) === quantity && !(this.config.duetLayout && pair); });
      for (let count = 1; count <= 3; count++) {
        const price = this.querySelector(`[data-ggbuy-tier-price="${count}"]`);
        if (!price) continue;
        const tier = selectedOffer(this.config, count, false, false, 0);
        price.textContent = this.money(tier.total);
        const original = this.querySelector(`[data-ggbuy-tier-original="${count}"]`);
        original.hidden = !tier.saving; original.textContent = this.money(tier.subtotal);
        const saving = this.querySelector(`[data-ggbuy-tier-saving="${count}"]`);
        saving.hidden = count !== 1 && !tier.saving;
        saving.textContent = count === 1 ? this.config.labels.tierOne : this.offerLabel(tier);

      }
      const context = this.querySelector('[data-ggbuy-cart-context]');
      context.hidden = !this.config.discountReady || !this.existing;
      context.textContent = this.config.labels.cartContext.replace('{count}', this.existing);
      if (this.config.duetLayout && this.config.pair) {
        const duet = selectedOffer(this.config, 1, true, false, 0);
        this.querySelector('[data-ggbuy-duet-price]').textContent = this.money(duet.total);
        const original = this.querySelector('[data-ggbuy-duet-original]');
        original.hidden = !duet.saving; original.textContent = this.money(duet.subtotal);
        const saving = this.querySelector('[data-ggbuy-duet-saving]');
        saving.hidden = !duet.saving; saving.textContent = this.offerLabel(duet);
      } else {
        this.config.pairs.forEach(candidate => {
          const card = this.querySelector(`[data-ggbuy-pair-card="${candidate.id}"]`);
          if (!card) return;
          const selectedIndex = pairs.findIndex(item => item.id === candidate.id);
          const otherPairs = selectedIndex < 0 ? pairs : pairs.slice(0, selectedIndex);
          const without = selectedOffer(this.config, valid ? quantity : 1, otherPairs, false, this.existing);
          const withPair = selectedOffer(this.config, valid ? quantity : 1, [...otherPairs, candidate], false, this.existing);
          const extraSaving = withPair.saving - without.saving;
          card.querySelector('[data-ggbuy-pair-price]').textContent = `+ ${this.money(candidate.price - extraSaving)}`;
          const saving = card.querySelector('[data-ggbuy-pair-saving]'); saving.hidden = !extraSaving;
          saving.textContent = extraSaving ? this.config.labels.saving.replace('{amount}', this.money(extraSaving)) : '';
        });
      }
      const glasses = this.config.labels.glasses.replace('__COUNT__', this.offer.glasses);
      this.querySelector('[data-ggbuy-progress-text]').textContent = glasses;
      this.querySelector('[data-ggbuy-progress]').style.width = `${Math.min(100, (quantity + pairs.length) / 3 * 100)}%`;
      const units = quantity + pairs.length;
      this.querySelector('[data-ggbuy-summary]').textContent = (units === 1 ? this.config.labels.packOne : this.config.labels.packs.replace('{count}', units)) + (bump ? ` + ${this.config.labels.bump}` : '');
      if (this.config.discountReady && this.existing) this.querySelector('[data-ggbuy-summary]').textContent = this.config.labels.additionTotal + ' · ' + this.querySelector('[data-ggbuy-summary]').textContent;
      this.querySelector('[data-ggbuy-total]').textContent = this.money(this.offer.total);
      this.querySelector('[data-ggbuy-button-price]').textContent = this.money(this.offer.total);
      const savings = this.querySelector('[data-ggbuy-saving]'); savings.hidden = !this.offer.saving;
      savings.textContent = this.config.labels.saving.replace('{amount}', this.money(this.offer.saving));
      const state = this.closest('[data-gg-buy]'); state.dataset.priceText = this.money(this.offer.total);
      this.product?.updateSticky?.();
    }
    async json(path, body) {
      const response = await fetch(this.dataset.root + path, { credentials: 'same-origin', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || this.config.labels.error);
      return result;
    }
    notice(message, cartLink = false) {
      this.status.replaceChildren(document.createTextNode(message));
      if (cartLink) { const link = document.createElement('a'); link.href = this.dataset.cartUrl; link.className = 'ggpb__fallback'; link.textContent = this.config.labels.cart; this.status.append(link); }
    }
    async add() {
      if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
      this.update(); this.busy = true;
      const quotedTotal = this.offer.total;
      const controls = [...this.form.querySelectorAll('button,input,select')].map(element => [element, element.disabled]);
      controls.forEach(([element]) => { element.disabled = true; });
      const sticky = this.product.querySelector('[data-gg-sticky-buy]'); if (sticky) sticky.disabled = true;
      this.button.setAttribute('aria-busy', 'true'); this.notice(this.config.labels.adding);
      const pairs = this.selectedPairs();
      const bump = this.querySelector('[data-ggbuy-extra="bump"]')?.checked;
      const items = [{ id: this.config.id, quantity: Number(this.quantity.value) }];
      pairs.forEach(pair => items.push({ id: pair.id, quantity: 1 }));
      if (bump && this.config.bump) items.push({ id: this.config.bump.id, quantity: 1 });
      let added = false;
      try {
        const before = await this.json('cart.js');
        this.setCart(before);
        if (this.offer.total > quotedTotal) { this.notice(this.config.labels.cartChanged, true); return; }
        await this.json('cart/add.js', { items }); added = true;
        let cart = await this.json('cart.js');
        if (this.config.discountReady) {
          const previous = (before.discount_codes || []).map(discount => discount.code).filter(code => ![this.config.codeTwo, this.config.codeThree].includes(code));
          cart = await this.json('cart/update.js', { discount: [...previous, this.config.codeTwo, this.config.codeThree].join(',') });
          // Shopify picks the best eligible code, including when cart quantities change.
          // Keep both tier codes and any existing customer code instead of stacking savings.
          if (cart.total_price - before.total_price > quotedTotal + ROUNDING_TOLERANCE) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            this.notice(this.config.labels.discountError, true); return;
          }
        }
        this.notice(this.config.labels.added, true);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        const trigger = document.querySelector('#cart-icon-bubble');
        if (trigger) trigger.click();
        else location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.notice(added ? this.config.labels.discountError : this.config.labels.error, true);
      } finally {
        controls.forEach(([element, disabled]) => { element.disabled = disabled; });
        this.busy = false; this.button.removeAttribute('aria-busy'); this.update();
      }
    }
  });
})();

